export default {
  all: "*",
  impersonation: "Impersonation",
  workloadFacultyHead: "Workloads.FacultyHead",
  workloadEmployee: "Workloads.Employee",
  workloadDegreeCoordinator: "Workloads.DegreeCoordinator",
  workloadViewOnly: "Workloads.ViewOnly",
  expertsEditor: "Experts.Editor",
  expertsAdmin: "Experts.Admin",
  expertsViewer: "Experts.Viewer",
  translationalTeam: "Placements.TranslationalTeam",
  translationalTeamAdmin: "TranslationalTeam.Admin",
  translationalTeamManager: "TranslationalTeam.TeamManager",
  translationalTeamViewer: "TranslationalTeam.Viewer", // added by Marina on August 11, 2022
  placementsAdvisor: "Placements.Advisor",
  placementsContractManager: "Placements.ContractManager",
  placementsViewer: "Placements.Viewer",
  placementsFaculty: "Placements.Faculty",

  // New roles: added by Marina on 10/28/2022
  awardsViewer: "Experts.Awards.Viewer",
  awardsManager: "Experts.Awards.Manager",
  projectsViewer: "Experts.Projects.Viewer",
  projectsManager: "Experts.Projects.Manager",
  proposalsViewer: "Experts.Proposals.Viewer",
  proposalsManager: "Experts.Proposals.Manager",
  cpManager: "Experts.CommunityParnterships.Manager",
  cpViewer: "Experts.CommunityParnterships.Viewer",
  placementsStudentManager: "Placements.Students.Manager",
  opportunitiesManager: "Placements.Opportunities.Manager",
  studentPlacementsManager: "Placements.Students.Manager"
};
